import styled from "@emotion/styled"

const Divider = styled.div`
  height: ${props => props.size}px;
`
export default Divider